import states from './states.json'

const stateCodes = Object.keys(states)
const codeByName = new Map(
  Object.entries(states).map(([code, name]) => [name.toUpperCase(), code]),
)

/** The option values of the application's US State select. */
export const US_STATE_CODES: readonly string[] = stateCodes

/**
 * The lead forms' (`components/LeadForm.js`, `VibeCodingLeadForm.tsx`) extra
 * State option for people outside the US; a lead carrying it has no US state
 * and its country is unknown.
 */
export const NOT_IN_US_LEAD_STATE = "I don't live in the US"

/**
 * The 2-letter code for a US state or territory given as a code or as its
 * full name, in any case or spacing (`"sc"`, `" South Carolina "` → `"SC"`),
 * or `''` when the value is neither. Leads created by ad platforms and lead
 * forms carry the full name, and the application's State select only knows
 * the codes.
 */
export function toUSStateCode(value: unknown): string {
  if (typeof value !== 'string') return ''
  const normalized = value.trim().toUpperCase()
  if (!normalized) return ''
  if (stateCodes.includes(normalized)) return normalized
  return codeByName.get(normalized) ?? ''
}
